import React from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import ModalEditContract from '../../Modals/EditContract.js';
import { isNotNullObject } from 'helpers/index.js';
import { TAB_DETAIL_CONTRACT, USE_DETAIL_CONTRACT } from 'constants/Contract.js';

const EditContract = (props) => {
  const { onSetMessage, isShowModalEdit, onSetShowModal, formDataContract, isOnBoard } = props;

  const { t } = useTranslation();

  return (
    <>
      {formDataContract && isNotNullObject(formDataContract) ? (
        <ModalEditContract
          formDataContract={{
            user_id: formDataContract.user_id,
            name: formDataContract.user_name,
            contract_id: formDataContract.id,
            type_contract: formDataContract?.contract_category_id,
            type_employee: formDataContract.group_id,
            code_contract: formDataContract.code,
            start_date: moment(formDataContract.start_date, 'DD/MM/YYYY'),
            end_date: moment(formDataContract.end_date, 'DD/MM/YYYY'),
            sent_mail: formDataContract.sent_mail,
            is_onboard: isOnBoard,
          }}
          onSetMessage={onSetMessage}
          isShowModal={isShowModalEdit}
          onSetShowModal={onSetShowModal}
          txtTitleModal={t('contract.editContract')}
          txtBtnModal={t('common.update')}
          type={TAB_DETAIL_CONTRACT}
          keyCache={USE_DETAIL_CONTRACT}
        />
      ) : (
        ''
      )}
    </>
  );
};

export default EditContract;
